import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import moment from 'moment';
import { HelpersService } from '../../../../../../services/helpers.service';
import { RentalsService } from '../../../../../../services/rentals.service';
import { BikeService } from '../../../../../../services/bike.service';
import { CyclistService } from '../../../../../../services/cyclist.service';
import { TechnicianService } from '../../../../../../services/technician.service';
import { PartnerService } from '../../../../../../services/partner.service';
import { ServiceRequestService } from '../../../../../../services/servicerequest.service';
import { AppConfig } from '../../../../../../app.config';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { ProductsService } from 'src/app/services/products.service';
import { ScheduleServiceComponent } from '../../../../../modals/schedule-service/schedule-service.component';
import { UpdateJobcardComponent } from '../../../../../modals/update-jobcard/update-jobcard.component';
import { AddEditProductCategoriesComponent } from '../../../../../modals/rentals/add-edit-product-categories/add-edit-product-categories.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NewJobcardService } from '../../../../../../services/new-jobcard.service';

@Component({
  selector: 'app-add-edit-rental-product',
  templateUrl: './add-edit-rental-product.component.html',
  styleUrls: ['./add-edit-rental-product.component.scss'],
})
export class AddEditRentalProductComponent implements OnInit {
  @Input() product;
  @Input() cloneProduct;
  @Input() messageService;
  @Output() close = new EventEmitter();

  public editing: boolean = false;
  public loading: boolean = false;
  public loadingServiceHistory: boolean = false;
  public preparingToBookService: boolean = false;
  public savingRentalProduct: boolean = false;
  public retiring: boolean = false;
  public uploadingPrimaryImage: boolean = false;
  public categoryOptions: any = [];
  public priceGroupOptions: any = [];
  public serialNumbers: any = [];
  public productServiceIndicatorConfig: any = null;
  public productServiceIndicatorDetailedConfig: any = [];
  public selectedServiceIndicatorComponent: any = null;
  public showAddServiceIndicatorEvent: boolean = false;
  public showSnoozeServiceIndicatorEvent: boolean = false;
  public showCreateServiceIndicatorServiceEvent: boolean = false;
  public selectedSnoozeServiceIndicatorComponent: any = null;
  public selectedServiceIndicatorServiceEventComponent: any = null;
  public savingServiceIndicatorEvent: boolean = false;
  public isServiceDue: boolean = false;
  public serviceIndicators: any = [];
  public sizeOptions: any = [
    { value: '12"', label: '12"' },
    { value: '16"', label: '16"' },
    { value: '20"', label: '20"' },
    { value: '24"', label: '24"' },
    { value: '26"', label: '26"' },
    { value: 'XS', label: 'XS' },
    { value: 'S', label: 'S' },
    { value: 'M', label: 'M' },
    { value: 'M/L', label: 'M/L' },
    { value: 'L', label: 'L' },
    { value: 'XL', label: 'XL' },
    { value: 'XXL', label: 'XXL' },
  ];
  public modules = {
    toolbar: [
      ['bold', 'italic', 'underline'], // toggled buttons
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
      ['clean'], // remove formatting button
    ],
  };
  public countryData: any = {};
  public partnerData: any = {};
  public products: any = [];
  public serviceHistory: any = [];
  public serviceIndicatorHistory: any = [];
  public newSku: any = null;
  public searchResult: any = [];
  public draft: boolean = false;
  public activeItem: MenuItem;
  public selectedTab: number;
  public tabs: MenuItem[] = [];
  public serviceSlotError: boolean = false;
  public moveData: any = {};
  public moveDataCategories: any = [];
  public moveDataPriceGroups: any = [];
  public moveDataInput: any = {
    destinationPartnerID: 0,
    categoryID: 0,
    priceGroupID: 0,
  };
  public movingProduct: boolean = false;
  public productMoved: boolean = false;
  menuChanged: boolean = true;

  public today: Date = moment(moment().format("YYYY-MM-DDT00:00:00")).toDate();
  public blockingProduct: boolean = false;
  public blockingDataInput: any = {
    id: 0,
    description: "",
    startDateTime: null,
    endDateTime: null,
  };
  public blockProductData: any = {};
  public showCancelBlockProduct: boolean = false;
  public setCalendarTimeFormat: number = 24;
  public selectedServiceIndicatorsForService: any = [];

  public readonly HEALTHY_THRESHOLD = 75;
  public readonly WARNING_THRESHOLD = 80;
  public readonly CRITICAL_THRESHOLD = 90;
  public readonly SERVICE_DUE_THRESHOLD = 100;
  public readonly currentDate = moment().endOf('day').toDate();

  public hasWorkShopSubscription: boolean = false;

  constructor(
    private rentalsService: RentalsService,
    private helpersService: HelpersService,
    private confirmationService: ConfirmationService,
    public translate: TranslateService,
    private productsService: ProductsService,
    private bikeService: BikeService,
    private cyclistService: CyclistService,
    private technicianService: TechnicianService,
    private partnerService: PartnerService,
    private serviceRequest: ServiceRequestService,
    private appConfig: AppConfig,
    private modalService: NgbModal,
    private newJobcardService: NewJobcardService,
  ) { }

  ngOnInit() {

    this.tabs = [
      {
        label: this.translate.instant('bikeshop.rentals.products.product_tab'),
        command: () => {
          this.selectedTab = 0;
        },
      },
      {
        label: this.translate.instant('bikeshop.rentals.service_indicator_status_report.service_indicator'),
        command: () => {
          this.selectedTab = 1;
        },
      },
      {
        label: this.translate.instant('bikeshop.rentals.products.block_product_label'),
        command: () => {
          this.selectedTab = 3;
        },
      }
    ];

    this.countryData = this.helpersService.getCountryData();
    this.setCalendarTimeFormat = this.countryData.code == 'US' ? 12 : 24;

    this.partnerData = this.helpersService.getPartnerData();
    this.getProductCategories();
    this.getPriceGroups();
    if (this.product.id) {
      this.editing = !this.cloneProduct;
      this.loading = true;
      this.getRentalProduct();
      this.getRentalProductMoveData();
      this.getRentalProductBlockData();
      this.getRentalProductServiceIndicatorConfig();
    } else {
      this.product.categoryID = 0;
      this.product.priceGroupID = 0;
      this.product.quantityToCreate = 1;
      this.product.statusID = 10;
      this.product.isRental = true;
      this.draft = true;
      this.updateSerialNumberArray();
    }
    document.documentElement.style.setProperty('--show-intercom', 'none');

    this.activeItem = this.tabs[0];
    this.selectedTab = 0;

    if (this.partnerData && this.partnerData.SubscribedProducts && this.partnerData.SubscribedProducts.length > 0) {
      this.hasWorkShopSubscription = this.partnerData.SubscribedProducts.some((x) => {
        return x.ProductType === "WORKSHOP"; // WorkShop Subscription
      });
    }
  }

  ngOnDestroy() {
    document.documentElement.style.setProperty('--show-intercom', 'inherit');
  }

  getProductCategories(defaultCategory = '') {
    this.rentalsService
      .getRentalProductCategories(this.helpersService.getPartnerId())
      .subscribe((res) => {
        this.categoryOptions = res.map((x) => {
          return { label: x.categoryName, value: x.id };
        });
        if (!this.product.id) {
          this.categoryOptions.splice(0, 0, {
            value: 0,
            label: this.translate.instant(
              'bikeshop.rentals.products.select_category',
            ),
          });
        }
        if (defaultCategory !== '') {
          var category = this.categoryOptions
            .filter((x) => {
              return x.label === defaultCategory;
            })
            .pop();
          if (category) {
            this.product.categoryID = category.value;
          }
        }
      });
  }

  getPriceGroups() {
    this.rentalsService
      .getRentalPriceGroups(this.helpersService.getPartnerId())
      .subscribe((res) => {
        this.priceGroupOptions = res.map((x) => {
          return { label: x.name, value: x.id };
        });
        var priceGroupOption = this.priceGroupOptions
          .filter((x: any) => {
            return x.value == this.product.priceGroupID;
          })
          .pop();
        if (!priceGroupOption) {
          this.product.priceGroupID = 0;
          this.priceGroupOptions.splice(0, 0, {
            value: 0,
            label: this.translate.instant(
              'bikeshop.rentals.products.select_price_group',
            ),
          });
        }
      });
  }

  getRentalProduct() {
    this.rentalsService
      .getRentalProduct(this.helpersService.getPartnerId(), this.product.id)
      .subscribe((product) => {
        if (this.cloneProduct && this.product.id) {
          this.product = {
            ...product,
            id: 0,
            bikeID: 0,
            activatedDate: moment().format('YYYY-MM-DD'),
            identifier: null,
            retiredDate: null,
            sellingPriceAfterRetirement: null,
            serialNumber: '',
            printableSerialNumber: '',
            quantityToCreate: 1,
            statusID: 10,
          };
          this.updateSerialNumberArray();
        } else {
          this.product = {
            ...product,
            activatedDate: product.activatedDate
              ? moment(product.activatedDate).format('YYYY-MM-DD')
              : moment().format('YYYY-MM-DD'),
          };
          this.getServiceHistory();
          this.rentalProductServiceIndicatorHistory();
        }
        this.loading = false;
      });
  }

  getRentalProductMoveData() {
    this.menuChanged = false;
    this.rentalsService
      .getRentalProductMoveData(
        this.helpersService.getPartnerId(),
        this.product.id,
        moment().local().format('YYYY-MM-DDTHH:mm:ss'),
      )
      .subscribe((data: any) => {
        this.moveData = data;
        if (this.moveData.stores && data.stores.length > 0) {
          this.tabs.push({
            label: this.translate.instant(
              'bikeshop.rentals.products.move_product',
            ),
            command: () => {
              this.selectedTab = 2;
            },
          });
        }
        this.menuChanged = true;

      }, err => {
        this.menuChanged = true;
      });
  }

  primaryUploader(event) {
    this.uploadingPrimaryImage = true;
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      this.product.imageURL = reader.result.toString();

      var mediaData = {
        PartnerID: this.helpersService.getPartnerId(),
        MediaData: reader.result.toString().replace(/^data:(.*;base64,)?/, ''),
      };
      this.rentalsService.uploadRentalImage(mediaData).subscribe(
        (res) => {
          this.product.imageURL = res.imageURL;
          this.uploadingPrimaryImage = false;
        },
        (err) => {
          this.product.imageURL = null;
          this.uploadingPrimaryImage = false;
        },
      );
    };
  }

  saveRentalProduct() {
    if (this.product.id > 0) {
      this.updateRentalProduct();
    } else {
      this.createRentalProduct();
    }
  }

  updateRentalProduct() {
    this.savingRentalProduct = true;
    this.rentalsService
      .updateRentalProduct(this.helpersService.getPartnerId(), this.product)
      .subscribe(
        (res) => {
          this.close.emit();
        },
        (err) => {
          this.savingRentalProduct = false;
        },
      );
  }

  createRentalProduct() {
    this.savingRentalProduct = true;
    var data = {
      ...this.product,
      defaultPartnerID: this.helpersService.getPartnerId(),
      serialNumbers: this.serialNumbers.map((x) => {
        return x.serialNumber;
      }),
    };
    this.rentalsService.addRentalProduct(data).subscribe(
      (res) => {
        this.close.emit();
      },
      (err) => {
        this.savingRentalProduct = false;
      },
    );
  }

  retireRentalProduct() {
    this.confirmationService.confirm({
      key: 'add_edit_rental_product',
      rejectLabel: this.translate.instant('general.no'),
      acceptLabel: this.translate.instant('general.yes'),
      header: this.translate.instant(
        'bikeshop.rentals.products.retire_rental_product',
      ),
      message: this.translate.instant(
        'bikeshop.rentals.products.retire_rental_product_message',
      ),
      accept: () => {
        this.retiring = true;
        this.product.statusID = 100;
        this.rentalsService
          .updateRentalProduct(this.helpersService.getPartnerId(), this.product)
          .subscribe(
            (res) => {
              this.messageService.add({
                life: 2000,
                detail: this.translate.instant(
                  'bikeshop.rentals.products.product_has_been_retired',
                  {
                    productName: this.product.brand + ' ' + this.product.model,
                  },
                ),
              });
              setTimeout(() => {
                this.close.emit();
              }, 1000);
            },
            (err) => {
              this.retiring = false;
            },
          );
      },
    });
  }

  searchProducts(event) {
    var results = this.products.filter(function (product) {
      return (
        product.SKU.toLowerCase().indexOf(event.query.toLowerCase()) > -1 ||
        product.Name.toLowerCase().indexOf(event.query.toLowerCase()) > -1 ||
        (product.SystemSKU !== null &&
          product.SystemSKU.toLowerCase().indexOf(event.query.toLowerCase()) >
          -1) ||
        (product.ManufacturerSKU !== null &&
          product.ManufacturerSKU.toLowerCase().indexOf(
            event.query.toLowerCase(),
          ) > -1)
      );
    });
    results = JSON.parse(JSON.stringify(results)).map((product) => {
      product.InternalProductID = JSON.parse(JSON.stringify(product)).ID;
      product.ID = 0;
      product.Quantity = 1;
      delete product.PartnerID;
      return product;
    });

    if (results.length > 0) {
      this.searchResult = results;
    } else {
      this.searchExternal(event);
    }
  }

  searchExternal(event) {
    this.productsService
      .searchProduct(this.helpersService.getPartnerId(), event.query)
      .subscribe((results) => {
        this.searchResult = results.map((item) => {
          return {
            ID: item.ID,
            SKU: item.Description,
            Name: item.Data,
            Quantity: 1,
          };
        });
      });
  }

  linkSku(sku) {
    this.product.internalProductID = sku.ID;
    this.product.linkedInternalProductSKU = sku.SKU;
    this.product.linkedInternalProductName = sku.Name;
  }

  isValid() {
    return (
      this.product.categoryID > 0 &&
      this.product.brand !== undefined &&
      this.product.brand.length > 0 &&
      this.product.model !== undefined &&
      this.product.model.length > 0 &&
      this.product.yearModel !== undefined &&
      this.product.yearModel >= 0 &&
      this.product.priceGroupID > 0 &&
      (this.product.isRental || this.product.isDemo) &&
      (this.editing || (!this.editing && this.product.quantityToCreate > 0))
    );
  }

  getServiceHistory() {
    this.loadingServiceHistory = true;
    this.bikeService.getJobCardForBike(this.product.bikeID).subscribe(
      (history) => {
        this.serviceHistory = history.sort((a, b) => {
          if (
            moment(a.DateCheckedIn).toDate() < moment(b.DateCheckedIn).toDate()
          )
            return 1;
          if (
            moment(a.DateCheckedIn).toDate() > moment(b.DateCheckedIn).toDate()
          )
            return -1;
          return 0;
        });
        this.loadingServiceHistory = false;
      },
      (err) => {
        this.loadingServiceHistory = false;
      },
    );
  }

  scheduleService() {

    this.getGetServiceIndicatorComponents()
    if (this.selectedServiceIndicatorsForService && this.selectedServiceIndicatorsForService.length > 0) {
      this.confirmationService.confirm({
        key: 'select_service_indicators',
        rejectLabel: this.translate.instant('general.cancel'),
        acceptLabel: this.translate.instant('bikeshop.modal.shedule_service.button.next'),
        header: this.translate.instant(
          'bikeshop.modal.shedule_service.schedule_service',
        ),
        accept: () => {
          this.intiateScheduleService();
        },
      });
    } else {
      this.intiateScheduleService();
    }
  }

  intiateScheduleService() {
    this.preparingToBookService = true;
    this.rentalsService
      .getFirstAvailableServiceSlot(
        this.partnerData.ID,
        moment().format('YYYY-MM-DDTHH:mm:ss'),
      )
      .subscribe(
        (availability) => {

          this.partnerService
            .getPartnerTechnicians(this.partnerData.ID)
            .subscribe((technicians) => {
              var technicianIDs = technicians
                .map((x) => {
                  return x.ID;
                })
                .join(',');

              this.bikeService
                .getBike(this.product.bikeID)
                .subscribe((bike) => {
                  this.cyclistService
                    .getCyclistById(bike.UserID)
                    .subscribe((customer) => {
                      this.preparingToBookService = false;

                      if (this.helpersService.getPartnerData().UseNewJobCard) {
                        this.newJobcardService.scheduleWorkshopService({
                          partnerId: this.helpersService.getPartnerId(),
                          partnerData: this.helpersService.getPartnerData(),
                          openJobCard: this.openJobCard.bind(this),
                          selectedItem: this.product,
                          customer: customer,
                          rentalBooking: true,
                          jobCardData: (result) => {
                            this.linkServiceIndicatorEventToWorkshopService(result.jobcard.ID);
                            this.getServiceHistory();
                          }
                        });
                        return;
                      }



                      const modalRef = this.modalService.open(
                        ScheduleServiceComponent,
                        {
                          size: 'lg',
                          backdrop: 'static',
                          backdropClass: 'modal-backdrop-rental-schedule',
                          windowClass: 'modal-rental-schedule'
                        },
                      );
                      modalRef.componentInstance.partnerId =
                        this.partnerData.ID;
                      modalRef.componentInstance.rentalBike = bike;
                      modalRef.componentInstance.rentalCustomer = customer;
                      modalRef.componentInstance.rentalBooking = true;
                      modalRef.componentInstance.selectedTimeSlot = moment
                        .utc(availability.slot)
                        .toDate();
                      modalRef.componentInstance.technician = {
                        id: availability.technicianID,
                        name: availability.technician,
                      };
                      modalRef.componentInstance.fromCalendar = true;
                      modalRef.result.then(
                        (result) => {
                          console.log(result);
                          this.linkServiceIndicatorEventToWorkshopService(result.jobcard.ID);
                          this.getServiceHistory();
                        },
                        (onrejected) => {
                          this.getServiceHistory();
                        },
                      );
                    });
                  this.serviceSlotError = false;
                });
            });
        },
        (err) => {
          this.preparingToBookService = false;
          this.serviceSlotError = true;
        },
      );
  }

  linkServiceIndicatorEventToWorkshopService(serviceID) {
    var list = [];
    if (this.selectedServiceIndicatorsForService && this.selectedServiceIndicatorsForService.length > 0) {
      this.selectedServiceIndicatorsForService.filter(x => { return x.selected }).forEach((item) => {
        list.push({
          productID: this.product.id,
          serviceIndicatorID: item.serviceIndicatorID,
          serviceIndicatorAdvancedID: item.serviceIndicatorAdvancedID,
          serviceIndicatorBasicID: item.serviceIndicatorBasicID,
          serviceID: serviceID,
        });
      });
      this.rentalsService.linkServiceEventToWorkShopService(list).subscribe(res => {
        this.getGetServiceIdicators();
      });
    }
  }

  getStatusDescription(service) {
    return this.appConfig.getStatusLabel(service.StatusID);
  }

  openJobCard(service) {

    if (this.helpersService.getPartnerData().UseNewJobCard) {
      this.newJobcardService.openManageJobCard(service.ID, {
        onRefreshEvents: () => {
          this.getServiceHistory();
          this.getGetServiceIdicators();
          this.rentalProductServiceIndicatorHistory();
        }
      });

      return;
    }

    this.serviceRequest
      .getServiceRequestData(service.ID)
      .subscribe((jobcard) => {
        const modalRef = this.modalService.open(UpdateJobcardComponent, {
          size: 'lg',
          backdrop: 'static',
          windowClass: 'jobcard-modal',
        });
        //modalRef.componentInstance.jobApproved = this.jobApproved[jobcard.ID];
        modalRef.componentInstance.jobcard = jobcard;
        modalRef.componentInstance.partnerID = this.partnerData.ID;
        modalRef.result.then(
          (result) => {
            this.getServiceHistory();
            this.getGetServiceIdicators();
            this.rentalProductServiceIndicatorHistory();
          },
          (onrejected) => {
            this.getServiceHistory();
            this.getGetServiceIdicators();
            this.rentalProductServiceIndicatorHistory();
          },
        );
      });
  }

  addCategory() {
    const modalRef = this.modalService.open(AddEditProductCategoriesComponent, {
      backdrop: 'static',
      windowClass: 'user-modal',
    });
    modalRef.componentInstance.messageService = this.messageService;
    modalRef.componentInstance.category = {};
    modalRef.result.then((result) => {
      this.getProductCategories(result.categoryName);
    });
  }

  updateSerialNumberArray() {
    if (this.product.quantityToCreate > this.serialNumbers.length) {
      let toAdd = this.product.quantityToCreate - this.serialNumbers.length;
      for (var i = 0; i < toAdd; i++) {
        this.serialNumbers.push({ serialNumber: '' });
      }
    } else if (this.product.quantityToCreate < this.serialNumbers.length) {
      this.serialNumbers.splice(this.product.quantityToCreate);
    }
  }

  onInitialValueChange() {
    this.updateSerialNumberArray();
  }

  storeSelected(event) {
    this.moveDataInput.categoryID = 0;
    this.moveDataInput.priceGroupID = 0;
    this.moveDataCategories = this.moveData.stores
      .filter((x: any) => {
        return x.value === event.value;
      })
      .pop().rentalCategories;
    this.moveDataPriceGroups = this.moveData.stores
      .filter((x: any) => {
        return x.value === event.value;
      })
      .pop().rentalPriceGroups;
  }

  productMoveValid() {
    return (
      this.moveDataInput.categoryID > 0 &&
      this.moveDataInput.priceGroupID > 0 &&
      this.moveDataInput.destinationPartnerID > 0
    );
  }

  moveRentalProduct() {
    var data = {
      sourcePartnerID: this.helpersService.getPartnerId(),
      productID: this.product.id,
      ...this.moveDataInput,
    };
    this.movingProduct = true;
    this.rentalsService.moveRentalProduct(data).subscribe(
      (res: any) => {
        this.messageService.add({
          life: 2000,
          detail: this.translate.instant(
            'bikeshop.rentals.products.rental_product_moved',
          ),
        });
        this.movingProduct = false;
        this.productMoved = true;
      },
      (err) => {
        this.movingProduct = false;
      },
    );
  }

  getRentalProductBlockData() {
    this.rentalsService
      .getRentalProductBlocks(this.helpersService.getPartnerId(), this.product.id)
      .subscribe((data: any) => {
        this.blockProductData = data;
      }, err => {

      });
  }

  productBlockValid() {
    if (this.blockingDataInput.description.length <= 0 || this.blockingDataInput.startDateTime == null || this.blockingDataInput.endDateTime == null) {
      return false;
    }

    if (this.blockingDataInput.endDateTime < this.blockingDataInput.startDateTime) {
      return false;
    }

    return true;
  }

  blockRentalProduct() {
    if (this.blockingDataInput.id == 0) {
      this.createNewRentalProductBlock();
    }
    else {
      this.updateRentalProductBlock();
    }
  }

  createNewRentalProductBlock() {
    var data = {
      PartnerID: this.helpersService.getPartnerId(),
      ProductID: this.product.id,
      Description: this.blockingDataInput.description,
      StartDateTime: moment(this.blockingDataInput.startDateTime).format('DD-MM-YYYY hh:mm A'),
      EndDateTime: moment(this.blockingDataInput.endDateTime).format('DD-MM-YYYY hh:mm A')
    };

    this.blockingProduct = true;

    this.rentalsService.createRentalProductBlock(data).subscribe(
      (res: any) => {
        this.blockProductData.push(res);

        if (this.messageService != undefined) {
          this.messageService.add({
            life: 2000,
            detail: this.translate.instant(
              'bikeshop.rentals.products.block_product.feedback.create',
            ),
          });
        }

        this.blockingProduct = false;
        this.cancelRentalProductBlock();
      },
      (err) => {
        this.blockingProduct = false;
      },
    );
  }

  editRentalProductBlock(item) {
    this.blockingDataInput.id = item.id;
    this.blockingDataInput.description = item.description;
    this.blockingDataInput.startDateTime = moment(item.startDateTime).toDate();
    this.blockingDataInput.endDateTime = moment(item.endDateTime).toDate();

    this.showCancelBlockProduct = true;
  }

  updateRentalProductBlock() {
    var data = {
      PartnerID: this.helpersService.getPartnerId(),
      ID: this.blockingDataInput.id,
      Description: this.blockingDataInput.description,
      StartDateTime: moment(this.blockingDataInput.startDateTime).format('DD-MM-YYYY hh:mm A'),
      EndDateTime: moment(this.blockingDataInput.endDateTime).format('DD-MM-YYYY hh:mm A')
    };

    this.blockingProduct = true;

    this.rentalsService.updateRentalProductBlock(data).subscribe(
      (res: any) => {
        const index = this.blockProductData.findIndex(i => i.id === res.id);
        if (index !== -1) {
          this.blockProductData[index] = res;
        }

        if (this.messageService != undefined) {
          this.messageService.add({
            life: 2000,
            detail: this.translate.instant(
              'bikeshop.rentals.products.block_product.feedback.update',
            ),
          });
        }

        this.blockingProduct = false;
        this.cancelRentalProductBlock();
      },
      (err) => {
        this.blockingProduct = false;
      },
    );
  }

  cancelRentalProductBlock() {
    this.blockingDataInput.id = 0;
    this.blockingDataInput.description = "";
    this.blockingDataInput.startDateTime = null;
    this.blockingDataInput.endDateTime = null;

    this.showCancelBlockProduct = false;
  }

  deleteRentalProductBlock(item) {
    this.rentalsService.deleteRentalProductBlock(this.helpersService.getPartnerId(), item.productID, item.id).subscribe(
      (res: any) => {
        const index = this.blockProductData.findIndex(i => i.id === item.id);
        if (index !== -1) {
          this.blockProductData.splice(index, 1);
        }

        if (this.messageService != undefined) {
          this.messageService.add({
            life: 2000,
            detail: this.translate.instant(
              'bikeshop.rentals.products.block_product.feedback.delete',
            ),
          });
        }

      },
      (err) => {

      },
    );
  }

  getRentalProductServiceIndicatorConfig() {
    this.rentalsService.getRentalProductServiceIndicatorConfig(this.helpersService.getPartnerId(), this.product.id).subscribe(response => {
      this.productServiceIndicatorConfig = response.productConfig;
      this.productServiceIndicatorDetailedConfig = response.productDetailedConfig.map((x) => {
        return { ...x, eventDate: moment(moment().format("YYYY-MM-DD HH:00:00")).toDate() }
      });
      if (this.productServiceIndicatorConfig && this.productServiceIndicatorConfig.serviceIndicatorsConfigured) {
        this.getGetServiceIdicators();
      }

      if (this.productServiceIndicatorDetailedConfig && this.productServiceIndicatorDetailedConfig.length === 1) {
        this.selectedServiceIndicatorComponent = this.productServiceIndicatorDetailedConfig[0];
      }
    });
  }

  getGetServiceIdicators() {
    this.rentalsService.getRenalServiceIndicators(this.helpersService.getPartnerId()).subscribe(response => {
      this.serviceIndicators = response.filter(x => { return x.isActive }).map((x) => {
        return { label: x.serviceIndicatorName, value: x.id };
      });
    });
  }

  updateProductServiceIndicatorLink(event) {
    this.confirmationService.confirm({
      key: 'add_edit_rental_product',
      rejectLabel: this.translate.instant('general.no'),
      acceptLabel: this.translate.instant('general.yes'),
      message: this.translate.instant('bikeshop.rentals.products.link_to_specific_service_indicator_confirm'),
      accept: () => {
        this.rentalsService.linkProductToServiceIdicator(this.helpersService.getPartnerId(), this.product.id, this.productServiceIndicatorConfig.serviceIndicatorID).subscribe(response => {
          this.getRentalProductServiceIndicatorConfig();
          this.messageService.add({
            life: 2000,
            detail: this.translate.instant('bikeshop.rentals.products.service_indicator_linked'),
          });
        });
      }, reject: () => {
        this.productServiceIndicatorConfig.serviceIndicatorID = event.originalEvent.target.value;
      }
    });
  }

  rentalProductServiceIndicatorHistory() {
    this.rentalsService.getRentalProductServiceIndicatorHistory(this.helpersService.getPartnerId(), this.product.id).subscribe(response => {
      this.serviceIndicatorHistory = response;
      this.checkServicesDue();
    });
  }

  checkServicesDue() {
    this.isServiceDue = false;
    this.serviceIndicatorHistory.forEach((item) => {
      if (item.indicatorStatus > this.SERVICE_DUE_THRESHOLD) {
        this.isServiceDue = true;
      }
    });
  }

  // Format date to a readable format
  formatDate(dateString: string | null): string {
    if (!dateString || !this.isValidDate(dateString)) {
      return 'N/A';
    }

    const date = moment.utc(dateString).local().toDate();
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  }

  // Check if date is valid
  isValidDate(dateString: string | null): boolean {
    if (!dateString) return false;

    const date = new Date(dateString);
    // Check if the date is valid and not the default date (0001-01-01)
    return !isNaN(date.getTime()) && date.getFullYear() > 1;
  }

  // Sort service history items by service date (descending)
  getSortedServiceHistory() {
    return this.serviceIndicatorHistory
      .filter(item => item.periodType === 'BETWEEN_SERVICES')
      .sort((a, b) => {
        // Sort by service date descending
        const dateA = new Date(a.serviceDate || '');
        const dateB = new Date(b.serviceDate || '');
        return dateB.getTime() - dateA.getTime();
      });
  }

  getMetricLabel(metric) {
    if (metric == 'Mileage')
      return this.translate.instant('bikeshop.rentals.service_indicators_config.configuration_metric_mileage');
    else if (metric == 'Hours')
      return this.translate.instant('bikeshop.rentals.service_indicators_config.configuration_metric_hours');
    else if (metric == 'TimeIntervalDays')
      return this.translate.instant('bikeshop.rentals.service_indicators_config.configuration_metric_time_interval_days');
    else if (metric == 'Points')
      return this.translate.instant('bikeshop.rentals.service_indicators_config.configuration_metric_points');
    else if (metric == 'RentalCount')
      return this.translate.instant('bikeshop.rentals.service_indicators_config.configuration_metric_rental_count');
    else
      return metric;
  }

  getMetricValueLabel(metric, value) {
    if (metric == 'Mileage')
      return this.partnerData.DefaultUnitOfMeasure === 1 ? (value === 1 ? 'Km' : 'Kms') : (value === 1 ? 'Mi' : 'Mls');
    else if (metric == 'Hours')
      return this.translate.instant(value === 1 ? 'bikeshop.rentals.booking.hour' : 'bikeshop.rentals.booking.hours');
    else if (metric == 'TimeIntervalDays')
      return this.translate.instant(value === 1 ? 'bikeshop.rentals.booking.day' : 'bikeshop.rentals.booking.days');
    else if (metric == 'Points')
      return this.translate.instant(value === 1 ? 'bikeshop.rentals.service_indicators_config.configuration_metric_point' : 'bikeshop.rentals.service_indicators_config.configuration_metric_points');
    else if (metric == 'RentalCount')
      return "(" + this.translate.instant('bikeshop.rentals.service_indicators_config.rental_count') + ")";
    else
      return metric;
  }

  getStatusPercentage(status: number): number {
    return Math.min(Math.round(status), 100);
  }


  getStatusClass(status: number): string {
    if (status < this.HEALTHY_THRESHOLD) return 'status-good';
    if (status < this.CRITICAL_THRESHOLD) return 'status-warning';
    if (status < this.SERVICE_DUE_THRESHOLD) return 'status-attention';
    return 'status-critical';
  }

  getStatusLabel(status: number): string {
    if (status < this.HEALTHY_THRESHOLD) return this.translate.instant('bikeshop.rentals.service_indicator_status_report.healthy');
    if (status < this.SERVICE_DUE_THRESHOLD) return this.translate.instant('bikeshop.rentals.service_indicator_status_report.approaching_service');
    return this.translate.instant('bikeshop.rentals.service_indicator_status_report.needs_service');
  }

  saveServiceIndicatorUsageEvent() {
    this.savingServiceIndicatorEvent = true;
    var data = {
      ...this.selectedServiceIndicatorComponent,
      eventDate: moment(this.selectedServiceIndicatorComponent.eventDate).utc().format('YYYY-MM-DD HH:mm:ss'),
      DefaultPartnerID: this.helpersService.getPartnerId()
    };
    this.rentalsService.addServiceIndicatorProductPoints(data).subscribe(response => {
      this.rentalProductServiceIndicatorHistory();

      if (this.productServiceIndicatorDetailedConfig && this.productServiceIndicatorDetailedConfig.length === 1) {
        this.selectedServiceIndicatorComponent.valueApplied = null;
        this.selectedServiceIndicatorComponent.eventDate = moment(moment().format("YYYY-MM-DD HH:00:00")).toDate();
      } else {
        this.selectedServiceIndicatorComponent.valueApplied = null;
        this.selectedServiceIndicatorComponent.eventDate = moment(moment().format("YYYY-MM-DD HH:00:00")).toDate();
        this.selectedServiceIndicatorComponent = null;
      }

      this.savingServiceIndicatorEvent = false;
      this.showAddServiceIndicatorEvent = false;
    }, err => {
      this.savingServiceIndicatorEvent = false;
    });
  }

  snoozeServiceIndicator(component) {
    this.showSnoozeServiceIndicatorEvent = true;
    if (this.productServiceIndicatorDetailedConfig && this.productServiceIndicatorDetailedConfig.length === 1) {
      this.selectedSnoozeServiceIndicatorComponent = JSON.parse(JSON.stringify(this.productServiceIndicatorDetailedConfig[0]));
    } else {
      var snoozeComponent = this.productServiceIndicatorDetailedConfig.filter((x) => {
        return x.component == component.component;
      }).pop();
      this.selectedSnoozeServiceIndicatorComponent = JSON.parse(JSON.stringify(snoozeComponent));
    }

    this.selectedSnoozeServiceIndicatorComponent.eventDate = moment().toDate();
  }

  saveSnoozeServiceIndicatorUsageEvent() {
    this.savingServiceIndicatorEvent = true;
    var data = {
      ...this.selectedSnoozeServiceIndicatorComponent,
      valueApplied: -1 * this.selectedSnoozeServiceIndicatorComponent.valueApplied,
      eventDate: moment(this.selectedSnoozeServiceIndicatorComponent.eventDate).utc().format('YYYY-MM-DDTHH:mm:ss'),
      DefaultPartnerID: this.helpersService.getPartnerId()
    };
    this.rentalsService.addServiceIndicatorProductPoints(data).subscribe(response => {
      this.rentalProductServiceIndicatorHistory();
      this.selectedSnoozeServiceIndicatorComponent = null;

      this.savingServiceIndicatorEvent = false;
      this.showSnoozeServiceIndicatorEvent = false;
    }, err => {
      this.savingServiceIndicatorEvent = false;
    });
  }

  createServiceIndicatorServiceEvent(component) {
    this.showCreateServiceIndicatorServiceEvent = true;
    if (this.productServiceIndicatorDetailedConfig && this.productServiceIndicatorDetailedConfig.length === 1) {
      this.selectedServiceIndicatorServiceEventComponent = JSON.parse(JSON.stringify(this.productServiceIndicatorDetailedConfig[0]));
    } else {
      var serviceComponent = this.productServiceIndicatorDetailedConfig.filter((x) => {
        return x.component == component.component;
      }).pop();
      this.selectedServiceIndicatorServiceEventComponent = JSON.parse(JSON.stringify(serviceComponent));
    }

    this.selectedServiceIndicatorServiceEventComponent.serviceDate = moment(moment().format("YYYY-MM-DD HH:00:00")).toDate();
  }

  saveServiceIndicatorServiceEvent() {
    this.savingServiceIndicatorEvent = true;
    var data = {
      ...this.selectedServiceIndicatorServiceEventComponent,
      serviceDate: moment(this.selectedServiceIndicatorServiceEventComponent.serviceDate).utc().format('YYYY-MM-DD HH:mm:ss'),
      DefaultPartnerID: this.helpersService.getPartnerId()
    }

    this.rentalsService.addServiceIndicatorProductServiceEvent(data).subscribe(response => {
      this.rentalProductServiceIndicatorHistory();
      this.selectedServiceIndicatorServiceEventComponent = null;
      this.showCreateServiceIndicatorServiceEvent = false;
      this.savingServiceIndicatorEvent = false;
    }, err => {
      this.savingServiceIndicatorEvent = false;
    });
  }

  getWorkshopServiceHistory() {
    if (this.productServiceIndicatorConfig && this.productServiceIndicatorConfig.serviceIndicatorID > 0) {
      return this.serviceHistory.filter((item) => {
        return item.StatusID < 40;
      });
    } else {
      return this.serviceHistory;
    }
  }

  getGetServiceIndicatorComponents() {
    var componentlist = this.serviceIndicatorHistory.filter((x) => {
      return x.periodType === 'AFTER_LAST_SERVICE' || x.periodType === 'NEVER_SERVICED';
    }).map((x) => {
      return {
        component: x.component,
        metric: x.metric,
        indicatorStatus: x.indicatorStatus,
        serviceIndicatorName: x.serviceIndicatorName,
        serviceIndicatorID: x.serviceIndicatorID,
        serviceIndicatorAdvancedID: x.serviceIndicatorAdvancedID,
        serviceIndicatorBasicID: x.serviceIndicatorBasicID,
        selected: x.indicatorStatus >= this.SERVICE_DUE_THRESHOLD
      };
    });
    this.selectedServiceIndicatorsForService = componentlist;
  }

}
